(() => {
  const FORM_SELECTOR = '[data-async-contact-form]';
  const SUBMISSION_KEY = 'academic-rp:contact-submission';
  const PUBLISHING_FORM_ID = 'PublishWithUsForm';

  const storePublishingAutoresponderSubmission = (form) => {
    if (form.id !== PUBLISHING_FORM_ID) return;

    const fieldValue = (selector) => form.querySelector(selector)?.value ?? '';

    try {
      localStorage.setItem('contact_auto_reply', '1');
      localStorage.setItem('contact_auto_reply_name', fieldValue('[name="contact[name]"]'));
      localStorage.setItem('contact_auto_reply_email', fieldValue('[name="contact[email]"]'));
      localStorage.setItem('contact_auto_reply_phone', fieldValue('[name="contact[phone]"]'));
      localStorage.setItem(
        'contact_auto_reply_message',
        JSON.stringify(fieldValue('[name="contact[body]"]'))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const setStatus = (form, type) => {
    const status = form.querySelector('[data-contact-status]');
    const successContent = status?.querySelector('[data-contact-success-content]');
    const errorContent = status?.querySelector('[data-contact-error-content]');

    if (!status || !successContent || !errorContent) return;

    const succeeded = type === 'success';
    successContent.hidden = !succeeded;
    errorContent.hidden = succeeded;
    status.hidden = false;
    status.setAttribute('role', succeeded ? 'status' : 'alert');
  };

  const readSubmission = () => {
    try {
      return JSON.parse(sessionStorage.getItem(SUBMISSION_KEY));
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const restoreSubmissionResult = () => {
    const url = new URL(window.location.href);
    const submission = readSubmission();

    if (url.searchParams.get('contact_posted') !== 'true' || !submission) return;

    const form = document.getElementById(submission.formId);
    if (form instanceof HTMLFormElement) setStatus(form, 'success');

    if (Number.isFinite(submission.scrollY)) {
      history.scrollRestoration = 'manual';
      const restoreScroll = () => window.scrollTo({ top: submission.scrollY, behavior: 'instant' });
      restoreScroll();
      requestAnimationFrame(restoreScroll);
    }

    sessionStorage.removeItem(SUBMISSION_KEY);
    url.searchParams.delete('contact_posted');
    url.hash = '';
    history.replaceState(null, '', `${url.pathname}${url.search}`);
  };

  document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
    if (form instanceof HTMLFormElement) form.dataset.asyncContactReady = 'true';
  });

  if (!window.academicRpContactFormsInitialized) {
    window.academicRpContactFormsInitialized = true;
    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

      storePublishingAutoresponderSubmission(form);

      sessionStorage.setItem(
        SUBMISSION_KEY,
        JSON.stringify({
          formId: form.id,
          scrollY: window.scrollY,
        })
      );
    });
  }

  restoreSubmissionResult();
})();
